import {
  FormErrorMessage as ChakraFormErrorMessage,
  FormErrorMessageProps as ChakraFormErrorMessageProps
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

import { Icon } from 'index';

const propTypes = {
  icon: PropTypes.node
};

const defaultProps = {
  icon: <Icon aria-label="Alert" boxSize="1.2em" marginRight="4px" type="AlertCircle" />
};

export type FormErrorMessageProps = Omit<ChakraFormErrorMessageProps, 'fontWeight'> & {
  fontWeight?: string;
  icon?: React.ReactElement;
};
export default function FormErrorMessage(props: FormErrorMessageProps): React.ReactElement {
  const { children, icon, ...rest } = props;

  return (
    <ChakraFormErrorMessage {...rest}>
      {icon}
      {children}
    </ChakraFormErrorMessage>
  );
}

FormErrorMessage.propTypes = propTypes;
FormErrorMessage.defaultProps = defaultProps;
